import { Routes, Route } from "react-router-dom";
import ViewerApp from "../ViewerApp";  // Fix import path to main App
import Dashboard from "./pages/Dashboard";  // Fix import path to Dashboard
import Entities from "./pages/Entities";
import Rules from "./pages/Rules";
import FilterTabs from "./pages/FilterTabs";
import Thresholds from "./pages/Thresholds";
import AdminLayout from "./layout/AdminlLayout";    
/* SET THE ROUTES */
export default function AdminApp() {  // Rename component to avoid naming conflict
    return (
        <AdminLayout>
            <Routes>
                {/* Admin area */}
                <Route path="/admin" element={<Dashboard />} />
                <Route path="/entities" element={<Entities />} />
                <Route path="/rules" element={<Rules />} />
                <Route path="/thresholds" element={<Thresholds />} />
                <Route path="/filter" element={<FilterTabs />} />

                {/* Fallback to viewer app for everything else
                 NEED TO CAHNGE IT . NEED TO MOVE THE APP SOMEWHERE*/}
                <Route path="/" element={<ViewerApp />} />
            </Routes>
        </AdminLayout>
    );
}